<template>
  <div class="modal-project-content">
    <!-- Modal Body Content -->
    <div v-if="!isFooterOnly">
      <div class="tabs is-boxed">
        <ul>
          <li
            v-for="(tab, i) in tabs"
            :class="[currentTabIndex === i ? 'is-active' : '']"
            :key="i"
          >
            <a @click="setTab(i)">{{ tab.name }}</a>
          </li>
        </ul>
      </div>
      <div class="tab-content-wrapper">
        <transition name="tab-fade" mode="out-in">
          <component
            :is="tabs[currentTabIndex].component"
            :key="currentTabIndex"
            :project-data="modalData"
          />
        </transition>
      </div>
    </div>

    <!-- Modal Footer Content -->
    <div v-if="isFooterOnly" class="modal-footer-buttons">
      <button
        v-if="tabs[currentTabIndex]?.hasSaveButton"
        :class="['button', 'is-success', isSaving ? 'is-loading' : '']"
        @click="handleSave"
      >
        Save
      </button>
      <button class="button" @click="closeTopModal">
        {{ tabs[currentTabIndex]?.hasSaveButton ? "Cancel" : "Close" }}
      </button>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from "vuex";
import General from "./tabs/General.vue";

export default {
  name: "ModalProject",
  components: {
    General,
  },
  props: {
    modalData: {
      type: Object,
      default: null,
    },
    modalIndex: {
      type: Number,
      default: 0,
    },
    isFooterOnly: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      tabs: [
        {
          name: "General",
          component: General,
          isActive: true,
          hasSaveButton: true,
        },
      ],
    };
  },
  computed: {
    ...mapState(["isSaving"]),
    ...mapGetters(["topModalActiveTabIndex", "topModal"]),
    currentTabIndex() {
      const topModal = this.topModal;
      if (topModal && topModal.type === "project") {
        return topModal.activeTabIndex || 0;
      }
      return 0;
    },
  },
  methods: {
    ...mapActions([
      "save",
      "closeTopModal",
      "updateModalTab",
      "updateTopModalData",
    ]),
    setTab(index) {
      this.updateModalTab(index);
    },
    handleSave() {
      this.$store.commit("SET_SELECTED_PROJECT", this.modalData);
      this.save();
    },
  },
  watch: {
    modalData: {
      immediate: true,
      handler(newData) {
        if (newData) {
          this.$store.commit("SET_SELECTED_PROJECT", newData);
        }
      },
    },
  },
};
</script>

<style scoped>
.modal-project-content {
  width: 100%;
}

.tab-content-wrapper {
  min-height: 400px;
  position: relative;
}

/* Tab transition animations */
.tab-fade-enter-active,
.tab-fade-leave-active {
  transition: opacity 0.2s ease, transform 0.2s ease;
}

.tab-fade-enter-from {
  opacity: 0;
  transform: translateX(10px);
}

.tab-fade-leave-to {
  opacity: 0;
  transform: translateX(-10px);
}

.tab-fade-enter-to,
.tab-fade-leave-from {
  opacity: 1;
  transform: translateX(0);
}

.modal-footer-buttons {
  display: flex;
  gap: 0.5rem;
  justify-content: flex-start;
}
</style>
